<template>
  <ModalDefault modal_id="addChannel"
                header="y"
                size="modal-md modal-dialog-scrollable"
                style_header=""
                :modal_header="getTranslations('expression_599') "
                :method="createChannel"
                :footer="new_channel.name && new_channel.type_key !== null"
                icon="bx bx-mobile-alt mr-1">
    <div class="px-2 py-2 pb-3" slot="body">
      <div class="d-flex">
        <div class="file-upload-center cursor-default w-100"  style="align-items: center; align-self: center;">
          <div class="d-block pt-0 px-2">
            <div class="col-12 px-0">
              <label class="mb-0">{{ getTranslations('expression_364') }}</label>
              <div class="input-group mb-3">
                <input type="text"
                       v-model="new_channel.name"
                       class="input_forms form-control">
              </div>
            </div>
            <div class="col-12 px-0">
              <label class="mb-0">{{ getTranslations('expression_595') }} </label>
              <div class="input-group mb-3">
                <select v-model="new_channel.type_key" @change="logTypeKey" class="input_forms custom-select">
                  <option :value="null" disabled>{{ getTranslations('expression_596') }}</option>
                  <option v-for="type in configs.data.channel_types"
                          :key="type.id"
                          :value="type.id">
                    {{ type.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="px-2 py-2">
      <span @click.prevent="createChannel" data-dismiss="modal" class="shadow-sm cursor_pointer animated--grow-in btn-secondary text-white py-2 px-3">
          <span class="">{{ getTranslations('expression_597') }}</span>
        </span>
    </div>
  </ModalDefault>
</template>

<script>
import ModalDefault from "../../components/general/ModalDefault";
import { mapGetters, mapState } from "vuex";
import $ from "jquery";

export default {
  name: "ModalAddChannel",
  components: {
    ModalDefault,
  },
  data() {
    return {
      new_channel: {
        name: null,
        type_key: null
      }
    };
  },
  computed: {
    ...mapState(['configs']),
    ...mapGetters([])
  },
  mounted() {
    $('#addChannel').on('hidden.bs.modal', () => {
      this.new_channel = {
        name: null,
        type_key: null
      };
    });
  },
  methods: {
    // Método de depuração que será chamado quando o select mudar
    logTypeKey() {
      
    },

    createChannel() {
      this.$store.dispatch("addChannel", this.new_channel);
      $('#addChannel').modal('hide');
    },
  }
}
</script>

<style scoped>
/* Seus estilos aqui */
</style>
